export const socialNotifications = {
  socialNotifTitle: "Aktiwiteit",
  socialNotifMarkAll: "Merk alles as gelees",
  socialNotifEmpty: "Nog geen aktiwiteit nie",
  socialNotifEmptyDesc: "Wanneer daar nuwe aktiwiteit is, sal jy dit hier sien",
  socialNotifJustNow: "So pas",
  socialNotifMinAgo: "{{count}}m gelede",
  socialNotifHrsAgo: "{{count}}u gelede",
  socialNotifDaysAgo: "{{count}}d gelede",
  socialNotifWeeksAgo: "{{count}}w gelede",
  socialNotifFollowers: "Volgers",
  socialNotifPrizes: "Pryse",
  socialNotifNewGames: "Nuwe speletjies",
  socialNotifPromos: "Promosies",
  socialNotifTournaments: "Toernooie",
  socialNotifComments: "Kommentaar",
};
